module.exports = __webpack_public_path__ + "img/QRdisabled.0a543ce4.svg";